module.exports = __webpack_public_path__ + "files/82e435674fa7e7ee0a1b7fbf1a2d8311.png";